<style scoped>

	.topBar{
	position: relative;
	}
	.numlitter{
	margin-right: 20px;
	}

	.iptlis{
	position: relative;
	}
	.iptlis .ico{
	position: absolute;
	right: 288px;
	top:23px;
	z-index: 11111; 
	}
	.zhiliang .daohang{
	margin-left: 20px;
	margin-top:10px;
	}
/*	.daohang{
	position: absolute;
	top:10px;
	left: 10px;
	z-index: 10;
	}*/
	.iptli{
	width:140px;
	border:none;
	height: 24px; 
	position: absolute;
	right: 168px;
	top:18px;
	cursor: pointer;
	background-color: #eaeaea;
	padding-left:30px;
	/*box-shadow: 3px 6px 6px 2px #E6E3F5;*/
	text-align:left;
	border-radius: 3px;
	z-index: 10;
	/*border-shadow:3px 6px;*/
	/*position: relative;*/
	}
	.iptc{
	height: 65px;
	/*        border-bottom: 1px solid #dddddd;
	border-top: 1px solid #dddddd;*/
	position: relative;
	background:url(../assets/header.gif)repeat-x 0 0px;
	background-color: #cdd9e8;
	border-color: #8ba0bc;
	}


	/*.numEve{
	margin-top:6px;
	}*/

	.daohang{
	position: absolute;
	top:10px;
	left: 10px;
	z-index: 10;
	}
.chaxun,.chongzhi{
    width:120px;
    height: 40px;
    background-color:#1d92be;
    border-radius: 10px;
    text-align: center;
    line-height: 40px;
    color: #f5f5f5;
    /*margin-top: 40px;*/
    display: inline-block;
    margin-right: 350px;
}
	.numEve{
	position: absolute;
	right: 61px;
	top:15px;
	line-height: 30px;
	background-color:#ffffff;
	height: 30px;
	width: 250px;
	text-align: right;
	color: #0066ff;
	}

	/*    .iptc{
	height: 40px;
	position: relative;
	}*/

	.serchlist input{
	width:200px;
	height: 30px;
	/*margin-top:30px;*/
	border:1px solid #dddddd;
	text-align: center;
		border-radius: 3px;
	}
	.serchlist span{
	width:50px;
	height: 20px;
	line-height: 30px;
	display: inline-block;
	text-align: center;
	background-color: white;
	}
/*	.serchlist select{
		width:200px;
	height: 30px;
	}*/

	.tab{
		width: 200px; min-height: 50px; line-height: 25px; text-align: center; border-collapse: collapse;
		float: left;
	}
	.tab, .tab tr td { border:1px solid #0094ff; }
	.tab tr{
		height: 50px;
	}
	.add_more_data_btn:hover{
           color:#2d8cf0;
        }
    .add_more_data_btn{
            width:100px;
            height:40px;
            line-height:40px;
            position: absolute;
            top: 5px;
            left:50%;
            transform: translateX(-50%);
            text-align:center;
            cursor:pointer;
        }
    .add_more_data{
        width:100%;
        height:60px;
        /*position: relative;*/
        text-align:center;
    }

/*	.sqrq{
    position: absolute;
    left: 128px;
    top:75px;
    background-color:white;
    height: 20px;
    z-index: 111;
    font-size: 13px;
	}*/

/*	.zzrq{
	position: absolute;
    left: 430px;
    top:75px;
    background-color:white;
    height: 20px;
    z-index: 111;
    font-size: 13px;
	}*/
	.serchlist .pz span{
    position: absolute;
    width:100px;
    left: 10px;
    top:-15px;
}
	.serchlist .chanpinyuanliao span{
    position: absolute;
    width:100px;
    left: 10px;
    top:-15px;
}
.serchlist .hou{
	margin-left: 100px !important;
}
.serchlist .pz,.ph,.hou,.kuan,.chang,.ck,.kunb,.muj,.chanpinyuanliao{
    position: relative;
    /*float: left;*/
    margin-left: 100px;
    margin-top: 20px;
    display: inline-block;
}
.serchlist .ph span{
	width:100px;
    position: absolute;
    left: 10px;
    top:-15px;
}

.serchlist .hou select,.ph input{
	border-left: 1px solid red !important;
	border-radius: 0px 3px 3px 0px;
}
.serchlist .hou span{
    position: absolute;
    left: 10px;
    top:-15px;
    z-index: 10;
}
.serchlist .kuan span{
    position: absolute;
    left: 10px;
    top:-15px;
}
.serchlist .chang span{
	width:100px;
	text-align:center;
    position: absolute;
    left: 10px;
    top:-15px;
}
.serchlist .ck span{
    position: absolute;
    left: 10px;
    top:-15px;
}
.serchlist .kunb span{
    position: absolute;
    left: 10px;
    top:-15px;
}
.serchlist .muj span{
    position: absolute;
    left: 10px;
    top:-15px;
}
.zhiliang{
	margin-bottom:90px;
	position: relative;
	height:800px;
}
.layout-content-right{
	margin-top:90px !important;
}
.bootBanner{
            overflow:hidden;
            min-width:100%;
            margin-top:50px;
            position: fixed;
            bottom:-4px;
            margin-top:30px;
            /*z-index: 10;*/
            /*height: 70px;*/
            /*overflow:hidden;*/
            margin-top:300px;
        }
        .bootBanner span span{
        float: right;
        width:120px;
        height:70px;
        line-height: 70px;
        border: 1px solid #ccc;
        text-align:center;
        /*background-color:#1d92be;*/
        cursor:pointer;
        font-size: 18px;
        margin-right: 5px;
        display: block;
        }
        /*.boo*/
        .bootBanner .ivu-icon{
            margin-right:5px;
            color: #ffffff;
            font-size: 20px;
        }
        .bootBanner .liang{
        /*background-color:red;*/
        background-color:#f5f7f9;
        display: block;
        /*width: %;*/
        height: 100px;
        margin-right:150px;
        /*margin-top:30px;*/
        /*position: fixed;*/
        /*bottom: -10px;*/
        /*margin-right: 20px;*/
        
        }
    /*    .bottomSpace{
        	width:800px;
        	height: 200px;
        	background-color:red;
        	margin-top: 200px;
        }*/
</style>

<template>
<div class="zhiliang">
<Scroll :on-reach-bottom="handleReachBottom" :distance-to-edge=[0,10] height="580">

	<div class="topBar">
		<div class="daohang">
			<span @click="tiaozhuan" style="cursor: pointer; font-size:20px;color:#2d8cf0;font-family:'微软雅黑' "><Icon type="ios-home"></Icon>{{language.shouye}}</span>>
			<span style="cursor: pointer; font-size:20px;font-family:'微软雅黑'">{{language.zhiliangshujuyufenxi}}</span>
		</div>
		<div class="iptc">
			<div class="iptlis">
				<Icon type="ios-search" class='ico'></Icon>
				<input  class="iptli" :placeholder=language.chaxunqingdianjiwo type="primary" @click="modal1 = true">
				<div class="numEve">
					<div class="numlitter">{{language.gong}}{{numnum}}{{language.tiao}}</div>
				</div>
			</div>
		</div>
	</div>
	<modal class="serchlist"  v-model="modal1"
	width="86%" :styles="{top: '60px',left:'100px'}">
<!-- 		<div class="hou">
			<span class='hous'>{{language.pinzhong}}</span>
		<Select :placeholder=language.qingxuanze v-model="numpinzhong" clearable style="width:200px">
			<Option v-for="item in cityList" :value="item.value" :key="item.value">{{item.label}}</Option>

		</Select>
		</div> -->
	<div class="ph">
		<Input type="text" class='paihao' v-model="numpaihao" clearable style="width: 200px"></Input><span class='paihaos'>{{language.gangchangziyuanhao}}</span>
	</div>
	<div class="kunb">
		<Input type="text" class='kunbaohao' v-model="numkunbaohao" clearable style="width: 200px"></Input><span class='kunbaohaos'>{{language.kunbaohao}}</span>
	</div>
	<div class="pz">
		<DatePicker type="date" v-model="numkuan"  style="width: 200px" class="qishi" @on-change="getDateTime"></DatePicker>
		<span>{{language.jiaohuoqishiriqi}}</span>
	</div>
	<div class="chang">
		<DatePicker type="date" v-model="numcangku"  style="width: 200px" class="zhongzhi" @on-change="getDateTimes"></DatePicker>
		<span>{{language.jiaohuozhongzhiriqi}}</span>

	</div>

	<div slot="footer" style="background-color:rgb(249,249,249);">
	<div class="chaxun" @click='chaxun()'>{{language.chaxun}}</div>
	<div class="chongzhi" @click='chongzhis()'>{{language.chongzhi}}</div>
	</div>
	</modal>
	        










	       <Table border :columns="columns1" :data="dataserch" class="border"></Table> 
<!--         	<div type="card" v-show='showtab2' class="tabNumber">
                <i-table :columns="columns2" :data="dataserch" border></i-table>
        	</div> 
        	<div type="card" v-show='showtab3' class="tabNumber">
                <i-table :columns="columns3" :data="dataserch" border></i-table>
        	</div>
        	<div type="card" v-show='showtab4' class="tabNumber">
                <i-table :columns="columns4" :data="dataserch" border></i-table>
        	</div> -->
        	<Col class="demo-spin-col" span="24" v-show="jiazai">
                    <Spin fix>
                        <Icon type="load-c" size=18 class="demo-spin-icon-load"></Icon>Loading
                        <!-- <div>Loading</div> -->
                    </Spin>
                </Col>
			<div class="add_more_data">
                <p  v-show="moredata">
                  {{language.jiazaiwanbi}}
                </p>
            </div>
</Scroll>

</div>
</template>
<script>
import axios from 'axios';
import config from 'config/apiConfig';
import language from 'api/language'
export default{
	data(){
		return{
			language:{},
			size:'',
			nextPage:'',
            numpaihao:'',
            numhou:'',
            numchang:'',
            numkuan:'',
            numcangku:'',
            cpyl:'',
            numkunbaohao:'',
            nummujuanhao:'',
            numnum:'',
            orderNum:'',
            packNumK:'',
            prodCode:'',
            dataserch:[],
			jiazai:false,
			moredata:false,
            modal1:false,
            columns1: [
            	
            	{
	                title: language.kunbaohao,
	                align:'center',
	                minWidth:85,
	                key: 'packNum'
	            },
	            {
	                title: language.gangjuanhao,
	                align:'center',
	                key: 'coilNumTc',
	                minWidth:100,
	            },
	            {
	                title: language.jianshu,
	                align:'center',
	                minWidth:85,
	                key: 'decimal'
	            },
	            {
	                title: language.luhao,
	                align:'center',
	                minWidth:80,
	                key: 'heatNumTc'
	            },
	            {
	                title: language.hou,
	                align:'center',
	                key: 'thickTc',
	                minWidth:80,
	            },
	            {
	                title: language.kuan,
	                align:'center',
	                key: 'widthTc',
	                minWidth:80,
	            },
	            {
	                title: language.chang,
	                align:'center',
	                key: 'lengthTc',
	                minWidth:80,
	            },
	            {
	                title: language.zhangshu,
	                align:'center',
	                minWidth:80,
	                key: 'n_pack'
	            },
	            {
	                title: language.zhongliang,
	                align:'center',
	                minWidth:80,
	                key: 'massTc'
	            },
	            {
	                title: language.qufu,
	                align:'center',
	                minWidth:80,
	                key: 'yieldStrengthTq'
	            },
	            {
	                title: language.kangla,
	                align:'center',
	                minWidth:80,
	                key: 'tensionStreTq'
	            },
	            {
	                title: language.shenchang,
	                align:'center',
	                minWidth:80,
	                key: 'elongationTq'
	            },
	            {
	                title: language.wanqushiyan,
	                align:'center',
	                minWidth:100,
	                key: 'bendTest;'
	            },
	            {
	                title: language.wanqujiaodu,
	                align:'center',
	                minWidth:100,
	                key: 'bendAngleHb'
	            },
	            {
	                title: language.wanquzhijing,
	                align:'center',
	                minWidth:100,
	                key: 'bendDimHb'
	            },
	            {
	                title: language.yingdu,
	                align:'center',
	                minWidth:100,
	                key: 'hardNessAv'
	            },
	            {
	                title: language.beitu,
	                align:'center',
	                minWidth:100,
	                key: 'erichsen'
	            },
	            {
	                title: language.BHzhi,
	                align:'center',
	                minWidth:100,
	                key: 'bhValue'
	            },




	            // {
	            //     title: language.zhengshuhao,
	            //     minWidth:150,
	            //     key: 'tcNumTc',
	            //     align:'center'
	            // },
	            // {
	            //     title: language.chanpinpinming,
	            //     minWidth:150,
	            //     align:'center',
	            //     key: 'prodName'
	            // },
	            // {
	            //     title: language.hetonghao,
	            //     minWidth:85,
	            //     align:'center',
	            //     key: 'orderNum'
	            // },
	            // {
	            //     title: language.biaozhunyi,
	            //     minWidth:85,
	            //     align:'center',
	            //     key: 'orderNum'
	            // },
	            // {
	            //     title: language.biaozhuner,
	            //     minWidth:85,
	            //     align:'center',
	            //     key: 'orderNum'
	            // },
	            // {
	            //     title: language.biaozhunsan,
	            //     minWidth:85,
	            //     align:'center',
	            //     key: 'orderNum'
	            // },
	            // {
	            //     title: language.biaozhunsi,
	            //     minWidth:85,
	            //     align:'center',
	            //     key: 'spec4Tc'
	            // },
	            // {
	            //     title: language.kehudingdanbianhao,
	            //     minWidth:85,
	            //     align:'center',
	            //     key: 'custOrdNum'
	            // },
	            // {
	            //     title: language.dayinriqi,
	            //     minWidth:85,
	            //     align:'center',
	            //     key: 'printDate'
	            // },

	            // {
	            //     title: language.jiaohuoriqi,
	            //     key: 'deliveryDateChr',
	            //     align:'center',
	            //     minWidth:120,
	            // },

	            
	            
	            
	            
	            
	            // {
	            //     title: language.biaojudaima,
	            //     align:'center',
	            //     minWidth:100,
	            //     key: 'typeElongationTq'
	            // },
	            
	            
	            
	            // {
	            //     title: language.qufubi,
	            //     align:'center',
	            //     minWidth:80,
	            //     key: 'yieldRatio;'
	            // },

	            // {
	            //     title: language.chongjifangxiang,
	            //     align:'center',
	            //     minWidth:100,
	            //     key: 'testDirectTq'
	            // },
	            // {
	            //     title: language.shiyanghoudu,
	            //     minWidth:100,
	            //     align:'center',
	            //     key: 'sampleThickness'
	            // },
	            // {
	            //     title: language.chongjiwendu,
	            //     align:'center',
	            //     minWidth:100,
	            //     key: 'testTempLcTq'
	            // },
	            // {
	            //     title: language.chongdiangong1,
	            //     align:'center',
	            //     minWidth:100,
	            //     key: 'impact1Tq'
	            // },
	            // {
	            //     title: language.chongdiangong2,
	            //     align:'center',
	            //     minWidth:100,
	            //     key: 'impact2Tq'
	            // },
	            // {
	            //     title: language.chongdiangong3,
	            //     align:'center',
	            //     minWidth:100,
	            //     key: 'impact3Tq'
	            // },
	            // {
	            //     title: language.Rzhileixing,
	            //     align:'center',
	            //     minWidth:100,
	            //     key: 'rType'
	            // },
	            // {
	            //     title: language.Rzhi,
	            //     align:'center',
	            //     minWidth:100,
	            //     key: 'averR'
	            // },
	            // {
	            //     title: language.Nzhileixing,
	            //     align:'center',
	            //     minWidth:100,
	            //     key: 'nType'
	            // },
	            // {
	            //     title: language.Nzhi,
	            //     align:'center',
	            //     minWidth:100,
	            //     key: 'averN'
	            // },
	            
	            
	            
	            // {
	            //     title: language.duxincengliangmian,
	            //     align:'center',
	            //     minWidth:100,
	            //     key: 'coatDouble'
	            // },
	            // {
	            //     title: language.duxincengshangmian,
	            //     align:'center',
	            //     minWidth:100,
	            //     key: 'coatTa'
	            // },
	            // {
	            //     title: language.duxincengxiamian,
	            //     align:'center',
	            //     minWidth:100,
	            //     key: 'coatBa'
	            // },
	        	],

        	
		}
		


	},
	methods:{
			handleReachBottom(){
                return new Promise(update => {
                    setTimeout(() => {
            let that=this;
                // that.resl=0;
                // console.log(index)
                let paramsData;
                // if(index==10){
                    paramsData={
            			"offset":that.nextPage,
            			"limit":'10',
		                // "prodCode" : that.numpinzhong,
		                "orderNum" : that.numpaihao,
		                "dateFrom" : that.numkuan,
		                "dateTo" : that.numcangku,
		                "dateTo" : that.cpyl,
		                "packNum" : that.numkunbaohao,
		                "deliveryPlan":"10"
					}
					if(that.size < 10){ that.moredata=true; return;that.jiazai=false}
					that.jiazai=true
            		axios.post(config.QualityInfos,paramsData).then(function(response){
            			if(response.data.resultCode == 1){
							that.jiazai=false
							that.dataserch=that.dataserch.concat(response.data.resultData.list)
							that.nextPage=response.data.resultData.nextPage
							that.size=response.data.resultData.size
							if(that.size<10){
								that.moredata=true;
							}
							that.$Message.info(language.jiazaiwanbi)
            			}else{
            				that.$Message.info(response.data.fsuffix)
            			}
                        
            		})

                    return
                // }
                        // const last = this.list1[this.list1.length - 1];
                        // for (let i = 1; i < 11; i++) {
                        //     this.list1.push(last + i);
                        // }
                        update();
                    }, 500);
                });
            },
			getDateTime(value){
                // console.log(value);
                this.numkuan = value;
            },
            getDateTimes(value){
                // console.log(value);
                this.numcangku = value;
            },
            chongzhis(){
                let that = this;
                // that.numpinzhong="";
                that.numpaihao="";
                that.numkuan="";
                that.numcangku="";
                that.cpyl="";

                that.numkunbaohao="";
            },
            tiaozhuan(){
                this.$router.push({name: 'firstpage',params:{ id:'1'}});
            },
            srechEve(){
                let that = this;
                if(that.raval==false){
                    that.raval=true
                }else{
                    that.raval=false
                }

			},
			//条件查询
            chaxun(){
                let that = this;
	            let params={};
	            params.orderNum = that.numpaihao;
	            params.dateFrom = that.numkuan;
	            params.dateTo = that.numcangku;
	            params.stockType = that.cpyl;
				params.packNum = that.numkunbaohao;
				params.prodCode -"";
	            axios.post(config.QualityInfos,params).then(function(response){
	                console.log(response)
                	that.$Message.info(language.qingshaodeng)
	                	if(response.data.resultCode==1){
	                    	that.dataserch=response.data.resultData.list
							that.numnum=response.data.resultData.total
							that.nextPage=response.data.resultData.nextPage
							that.size=response.data.resultData.size
	                    	that.modal1=false
	                        console.log(that.dataserch)
	                    }else{
	                    	that.$Message.info('查询失败')
	                    }
	                })
            },
            update(index){
            	let that=this;
                // that.resl=0;
            	// console.log(index)
            	let paramsData;
            	if(index==10){
            		paramsData={
            			"offset":that.nextPage,
            			"limit":'10',
		                "prodCode" : that.numpinzhong,
		                "orderNum" : that.numpaihao,
		                "dateFrom" : that.numkuan,
		                "dateTo" : that.numcangku,
		                "dateTo" : that.cpyl,
		                "packNum" : that.numkunbaohao,
            		}
            		axios.post(config.QualityInfos,paramsData).then(function(response){
            			if(response.data.resultCode == 1){
							that.dataserch=that.dataserch.concat(response.data.resultData.list)
							that.nextPage=response.data.resultData.nextPage
							that.size=response.data.resultData.size
            				that.$Message.info(language.jiazaiwanbi)
            			}else{
            				that.$Message.info(response.data.fsuffix)
            			}

            		})

            		return
            	}
            },
	},
	mounted(){
		this.language=language
		this.chaxun()
	}
}
</script>


// WEBPACK FOOTER //
// qualitative.vue?2496c828